import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { SpinnerService } from 'app/services/spinner.service';

declare var jQuery: any;

@Component({
  selector: 'app-blank',
  templateUrl: 'blankLayout.template.html'
})
export class BlankLayoutComponent implements AfterViewInit, OnDestroy {

  constructor(public spinnerService: SpinnerService) {

  }

  ngOnInit() {
    this.spinnerService.fullStop();2
  }

  ngAfterViewInit() {
    jQuery('body').addClass('gray-bg');
  }

  ngOnDestroy() {
    jQuery('body').removeClass('gray-bg');
  }
}
